import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { CatalogAdjustmentReason } from "@/pages/configuration/models/CatalogAdjustmentReason";

type Props = {
	setSelectedRowData: (adjustmentReason: CatalogAdjustmentReason) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	handleNewReason: () => void;
	editAdjustmentReason: (data: CatalogAdjustmentReason) => void;
};
export const useAdjustmentReasonOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	handleNewReason,
	editAdjustmentReason,
}: Props) => {
	const getMenuOptions = (data: CatalogAdjustmentReason) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Adj. Reason",
				key: "new_adjustment_reason",
				onClick: () => {
					handleNewReason();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Adj. Reason",
					key: "edit_adjustment_reason",
					onClick: () => {
						editAdjustmentReason(data);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Adj. Reason",
					key: "delete_adjustment_reason",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
